import { useMutation } from "@tanstack/react-query";

import { deleteFieldEvaluationMetricCorrection } from "services";

import { invalidateQueriesByChunk } from "utils";

import { DELETE_FIELD_EVALUATION_METRIC_CORRECTION, GET_FIELD_EVALUATION_METRIC_CORRECTIONS } from "consts";

export const useDeleteFieldEvaluationMetricCorrection = (fieldId: string) =>
  useMutation({
    mutationKey: [DELETE_FIELD_EVALUATION_METRIC_CORRECTION],
    mutationFn: deleteFieldEvaluationMetricCorrection,
    onSuccess: () => {
      invalidateQueriesByChunk(GET_FIELD_EVALUATION_METRIC_CORRECTIONS, fieldId);
    },
  });
